import { render } from "./ShowPayentries.vue?vue&type=template&id=227ae026&scoped=true"
import script from "./ShowPayentries.vue?vue&type=script&lang=js"
export * from "./ShowPayentries.vue?vue&type=script&lang=js"

import "./ShowPayentries.vue?vue&type=style&index=0&id=227ae026&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-227ae026"

export default script